export default __webpack_public_path__ + "locales/vi/OAuth.json?hash=1b5e22ec55c02787fee5a74992f0ebc8";